var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTable',{attrs:{"hide-title":true,"headers":_vm.headers,"items":_vm.items,"total-rows":_vm.items.length,"actions":_vm.actions,"elevation":0}})}
var staticRenderFns = []

export { render, staticRenderFns }